import PropTypes from "prop-types";

import { ParcelTypes } from "../../../models/types";
import AdditionalInformation from "../components/AdditionalInformation";
import HeaderWithDetails from "../components/HeaderWithDetails";
import ParcelAdditionalStatus from "../components/ParcelAdditionalStatus";
import ParcelHistory from "../components/ParcelHistory/ParcelHistory";
import RelatedParcels from "../components/RelatedParcels";

const IssueParcelView = ({
  parcel,
  children,
  isRelatedParcelsAvailable,
  onClickDeliveryHistory,
  onClickConsignment,
  onClickAdditionalInformation,
}) => (
  <>
    <HeaderWithDetails
      parcel={parcel}
      additionalParcelStatus={<ParcelAdditionalStatus parcel={parcel} />}
    />
    {children}
    <ParcelHistory data={parcel.parcelEvents} onOpen={onClickDeliveryHistory} />
    {isRelatedParcelsAvailable && (
      <RelatedParcels
        parcelCode={parcel.parcelCode}
        onOpen={onClickConsignment}
      />
    )}
    <AdditionalInformation
      parcel={parcel}
      onOpen={onClickAdditionalInformation}
    />
  </>
);
IssueParcelView.propTypes = {
  parcel: PropTypes.shape(ParcelTypes.Parcel),
  children: PropTypes.node,
  onClickDeliveryHistory: PropTypes.func,
  onClickConsignment: PropTypes.func,
  onClickAdditionalInformation: PropTypes.func,
};

export default IssueParcelView;
